"use client";

import { useContext } from "react";
import { HomeBannerContext } from "./home-banners-context/home-banners-context";
import { PracticeExamHomeBanner } from "@/components/exams/practice-exam/practice-exam-home-banner";

export const HomePracticeExamBanner = ({
  closeBanner,
}: {
  closeBanner?: () => void;
}) => {
  const { practiceExamStatus } = useContext(HomeBannerContext);

  return (
    <PracticeExamHomeBanner
      closeBanner={closeBanner}
      practiceExamStatus={practiceExamStatus}
    />
  );
};
